import { useContext } from 'react';
import { List } from 'react-feather';
import styled from '@emotion/styled';
import { ProjectClipsFiltersContext } from '../../contexts/project-clips/Context';

export const ClipsTableEmpty = () => {
  const filters = useContext(ProjectClipsFiltersContext);
  const copy = filters.keyword ? searchCopy : tagsCopy;

  return (
    <Wrap>
      <List size={120} />
      <Message>{copy.message}</Message>
      <Note>{copy.note}</Note>
    </Wrap>
  );
};

ClipsTableEmpty.displayName = 'ProjectClips.ClipsTableEmpty';

const tagsCopy = {
  message: 'No clips available.',
  note: 'Tag and highlight transcripts to view highlights from the interview.',
};
const searchCopy = {
  message: 'No results found.',
  note: 'Try updating filters or searching for a different keyword.',
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 12px;
  color: #aaa;
`;

const Message = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #555;
  margin: 0;
`;

const Note = styled.p`
  font-size: 13px;
  color: #999;
  margin: 0;
`;
